import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
		providedIn: 'root'
	})
export class CacheService {

	private url = 'ws/caches';

	constructor(private http: HttpClient) {
	}

	/**
	 * WS pour sigale backend 2
	 */
	lister(): Observable<any> {
		return this.http.get(this.url + '/lister');
	}

	/**
	 * WS pour sigale backend 1
	 */
	statistics(): Observable<any> {
		return this.http.get(this.url + '/statistics');
	}

	clear(cache: String[]): Observable<any> {
		return this.http.post(this.url + '/clear', cache);
	}
}
